var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconReplicateMenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 46,
  viewBox: "0 0 42 46",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 0.5H5.25V45.5H0.75V0.5ZM36.75 0.5H7.5V45.5H36.75C39.2318 45.5 41.25 43.4818 41.25 41V5C41.25 2.51825 39.2318 0.5 36.75 0.5ZM34.5 23H14.25V18.5H34.5V23ZM34.5 14H14.25V9.5H34.5V14Z",
  fill: "#949494"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReplicateMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_replicate_menu.2d8e988f.svg";
export { ForwardRef as ReactComponent };